import { Grid, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import { AjqErrorsCard } from '../../components/dashboard/AjqErrorsCard';
import { ErrorsByOrgChart } from '../../components/dashboard/ErrorsByOrgChart';
import { LateCampaignsCard } from '../../components/dashboard/LateCampaignsCard';
import { ReliusArchivedPlansCard } from '../../components/dashboard/ReliusArchivedPlansCard';
import { RkeqErrorsCard } from '../../components/dashboard/RkeqErrorsCard';
import { SsoErrorsChart } from '../../components/dashboard/SsoErrorsChart';
import { StuckAjqCard } from '../../components/dashboard/StuckAjqCard';
import { TiaaSiaCard } from '../../components/dashboard/TiaaSiaCard';

const CARD_SIZE = { md: 4, sm: 6, xl: 2, xs: 12 };

const DashboardPage = () => (
  <Stack spacing={2} sx={{ p: 2 }}>
    <Typography variant='h5'>Dashboard</Typography>

    <Grid container data-testid='dashboardSnapshots' spacing={2}>
      <Grid size={CARD_SIZE}>
        <AjqErrorsCard />
      </Grid>
      <Grid size={CARD_SIZE}>
        <StuckAjqCard />
      </Grid>
      <Grid size={CARD_SIZE}>
        <RkeqErrorsCard />
      </Grid>
      <Grid size={CARD_SIZE}>
        <LateCampaignsCard />
      </Grid>
      <Grid size={CARD_SIZE}>
        <ReliusArchivedPlansCard />
      </Grid>
      <Grid size={CARD_SIZE}>
        <TiaaSiaCard />
      </Grid>
    </Grid>

    <ErrorsByOrgChart />

    <SsoErrorsChart />
  </Stack>
);

export const Route = createFileRoute('/dashboard/')({
  component: DashboardPage
});
